import { useTranslation } from 'react-i18next'

import { AvatarWithStatus } from '../../../../Avatar'
import { EntityProfileHeaderInfoItemBase } from '../../../../Entity'
import Text from '../../../../Text'
import { ProfileUsersWidgetItem } from '../../../../Widget'
import {
  APPLICANT_PROFILE_INFO_ITEM_TITLE_KEY,
  QA_NAME_APPLICANT_PROFILE_INFO_RESPONSIBLE_MANAGER,
} from '../RentalPortalApplicantProfileHeaderInfoItems.constants'
import {
  getApplicantProfileHeaderInfoItemActions,
  getApplicantProfileManagerItemProps,
  toApplicantProfileUserValue,
} from '../RentalPortalApplicantProfileHeaderInfoItems.utils'

function ApplicantProfileResponsibleManagerItem({
  actionButtonClassName,
  actionsWrapperClassName,
  canEdit,
  className,
  contentWrapperClassName,
  managerClassName,
  titleClassName,
  value,
  onOpenModal,
}) {
  const { t } = useTranslation()

  return (
    <EntityProfileHeaderInfoItemBase
      {...getApplicantProfileManagerItemProps({
        actionButtonClassName,
        actionsWrapperClassName,
        canEdit,
      })}
      className={className}
      contentExist={Boolean(value)}
      contentWrapperClassName={contentWrapperClassName}
      handlers={getApplicantProfileHeaderInfoItemActions(onOpenModal)}
      title={APPLICANT_PROFILE_INFO_ITEM_TITLE_KEY.responsibleManager}
      titleClassName={titleClassName}
      value={value?.id}
    >
      {value ? (
        // TODO: mock applicants carry mock users, so the user is not a link until they are served
        <ProfileUsersWidgetItem
          blocked
          AdditionalInfo={null}
          ContentAvatar={AvatarWithStatus}
          className={managerClassName}
          hoverClassName={null}
          isArchived={Boolean(value.is_archived)}
          textQaName={QA_NAME_APPLICANT_PROFILE_INFO_RESPONSIBLE_MANAGER}
          value={toApplicantProfileUserValue(value)}
        />
      ) : (
        <Text
          disabled
          isSecondary
          qaName={QA_NAME_APPLICANT_PROFILE_INFO_RESPONSIBLE_MANAGER}
        >
          {t('Select.NoDataKey')}
        </Text>
      )}
    </EntityProfileHeaderInfoItemBase>
  )
}

export default ApplicantProfileResponsibleManagerItem
